import React from 'react';

import MerchantBranchFilterColumn from "../../shared/component/dataTable/columns/MerchantBranchFilterColumn.json";

import DataTable from "../../shared/component/dataTable/DataTable";

import {Button} from "reactstrap";

import Translate from "../../shared/language/Translate";

import '../../shared/styles/SettingsPage.css';



export default class MerchantBranchFilter extends React.Component {

    constructor(props) {

        super(props);

        this.state = {};

    }



    componentDidMount() {

        this.refreshDataTable();

    }



    render() {

        return (

            <div className="settings-page settings-page--dialog settings-page--lookup-picker">

                <h2 className="settings-page__section-title">Merchant Branches</h2>

                <div className="settings-page__table-wrap settings-page__table-wrap--lookup-dialog settings-page__table-wrap--lookup-dialog-wide">

                    <DataTable ref={(elem) => this.refDataTable = elem}

                               fields={MerchantBranchFilterColumn.fields}

                               objectName={MerchantBranchFilterColumn.name}

                               dataURL="crm/merchant/branch/all"

                               rows={10}

                               closeFilterDialog={this.props.closeDisplayDialog}

                               onDataSelect={this.onDataSelect}

                               selectionMode="single"

                               loading={this.state.loading}/>

                </div>

                <div className="settings-page__actions settings-page__actions--dialog-footer">

                    <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close"

                            onClick={() => this.props.closeDisplayDialog()}>

                        <Translate contentKey="entity.action.cancel">Close</Translate>

                    </Button>

                </div>

            </div>

        );

    }



    refreshDataTable = () => {

        this.refDataTable.refresh();

    }



    onDataSelect = (data) => {

        this.props.onDataSelect(data);

    }

}

